import { resourcesBaseUri } from "../config";
import { Dictionary } from "../util/types";

export type LocalSystems = 'rba' | 'ip' | 'mascus';

export type LocalSystemConfigs = Dictionary<LocalSystemConfig> & {
	[System in LocalSystems]: LocalSystemConfig<System>;
}

export type LocalSystemConfig<System extends LocalSystems = LocalSystems> = {
	id: System;
	path: `/${System}`;
	name: string;
	logo: string;
	icon: string;
}

export const localSystems: LocalSystemConfigs = {
	'rba': {
		id: 'rba',
		path: '/rba',
		name: 'Ritchie Bros. Auctioneers',
		logo: `${resourcesBaseUri}/rba.svg`,
		icon: `${resourcesBaseUri}/rba-icon.svg`
	},
	'ip': {
		id: 'ip',
		path: '/ip',
		name: 'IronPlanet',
		logo: `${resourcesBaseUri}/iron-planet.png`,
		icon: `${resourcesBaseUri}/ip-icon.svg`
	},
	'mascus': {
		id: 'mascus',
		path: '/mascus',
		name: 'Mascus',
		logo: `${resourcesBaseUri}/mascus-logo.png`,
		icon: `${resourcesBaseUri}/mascus-icon.svg`
	}
};

export function isSupportedSystem(system: string): system is LocalSystems {
	return system in localSystems;
}